export enum CommonConstant {
    FP_THONG_KE = "Thống kê",
    FP_FORM_REGISTER = "Đăng ký",
    FP_FORM_DYNAMIC = "Biểu mẫu đăng ký",
    FP_USER_CLBCV_MNG = "Phật tử CLB Cúc Vàng",
    FP_USER_CLBTT_MNG = "Phật tử CLB Tuổi Trẻ" ,
    FP_USER_CLBLHL_MNG = "Khóa sinh La Hầu La" ,
    FP_PHAN_QUYEN = "Phân quyền (Quản trị web)" ,

    ITEMS_PER_PAGE = "Số hàng mỗi trang",

    //Token 
    CURRENT_TOKEN = "CLB-Cuc-Vang-Token",
    CURRENT_USER = "CLB-Cuc-Vang-User",
    CURRENT_USER_PERMISSIONS = "CLB-Cuc-Vang-User-Permission",
    TEMPLATE_IMPORT_CLB_LHL = "Mẫu_Nhập_Khóa_Sinh_La_Hầu_La.xlsx",
    TEMPLATE_IMPORT_CLB_TT = "Mẫu_Nhập_CLB_Tuổi_Trẻ.xlsx",
    TEMPLATE_IMPORT_CLB_TT_KHOI = "Mẫu_Nhập_CLB_Tuổi_Trẻ (Khối).xlsx",

}
// Thành phần Phật tử
export const THANH_PHAN_KHOA_SINH = [
  { value: 'CHÍNH THỨC', label: 'CHÍNH THỨC' },
  { value: 'GIEO DUYÊN', label: 'GIEO DUYÊN' }
];

// Thành phần Phật tử
export const CHUC_DANH_TAI_KHOI = [
  { value: 'LĐ Khối', label: 'LĐ Khối' },
  { value: 'CS Khối', label: 'CS Khối' },
  { value: 'Phát tâm Bồ đề (A)', label: 'Phát tâm Bồ đề (A)' },
  { value: 'Tin nhân quả (B)', label: 'Tin nhân quả (B)' },
  { value: 'Tìm hiểu Phật Pháp (C)', label:'Tìm hiểu Phật Pháp (C)' },
  { value:  'Gieo duyên Phật Pháp (D)', label:  'Gieo duyên Phật Pháp (D)'}
];

// Khóa sinh thuộc diện?
export const KHOA_SINH_THUOC_DIEN = [
  { value: 'Không mồ côi', label: 'Không mồ côi' },
  { value: 'Mồ côi mẹ', label: 'Mồ côi mẹ' },
  { value: 'Mồ côi bố', label: 'Mồ côi bố' },
  { value: 'Mồ côi cả bố và mẹ', label: 'Mồ côi cả bố và mẹ' },
  { value: 'Bố mẹ ly thân', label: 'Bố mẹ ly thân' },
  { value: 'Bố mẹ đã ly hôn', label: 'Bố mẹ đã ly hôn' },
  { value: 'Sinh ra không biết bố/mẹ là ai', label: 'Sinh ra không biết bố/mẹ là ai' },
  { value: 'Bố/mẹ bỏ đi từ nhỏ', label: 'Bố/mẹ bỏ đi từ nhỏ' }
];

// Gia đình có thuộc diện khó khăn hay không?
export const GD_KHO_KHAN = [
  { value: 'Không khó khăn', label: 'Không khó khăn' },
  { value: 'Khó khăn (Có chứng nhận hộ nghèo/cận nghèo)', label: 'Khó khăn (Có chứng nhận hộ nghèo/cận nghèo)' },
  { value: 'Hoàn cảnh khó khăn (Chưa có chứng nhận)', label: 'Hoàn cảnh khó khăn (Chưa có chứng nhận)' }
];
export const THANH_PHAN_BO_ME_KHOA_SINH = [
'Phật tử thành phần A',
'Phật tử thành phần B',
'Phật tử thành phần C',
'Phật tử thành phần D',
];

// Thành phần Phật tử
export enum CHUC_DANH_TAI_KHOI_VALUE {
  LD_KHOI = 'LĐ Khối',
  CS_KHOI = 'CS Khối',
  PHAT_TAM_BO_DE = 'Phát tâm Bồ đề (A)',
  TIN_NHAN_QUA = 'Tin nhân quả (B)',
  TIM_HIEU_PHAT_PHAP = 'Tìm hiểu Phật Pháp (C)',
  GIEO_DUYEN_PHAT_PHAP = 'Gieo duyên Phật Pháp (D)'
};
export const COMMON_PHONE_REGEX = /^\+?\d{7,15}$/;

export const VAI_TRO_BQC_KHOI_LHL = [
  { value: 'Trưởng khối', label: 'Trưởng khối' },
  { value: 'Phó khối', label: 'Phó khối' },
   { value: 'Thành viên khối', label: 'Thành viên khối' }
];